<script src="main.js"></script>
<template>
  <v-responsive>
    <v-app>
      <!--BARRA TOP-->
      <v-app-bar app elevation="0" class="color" dark color="indigo darken-4" dense style="z-index: 99;">
        <v-app-bar-nav-icon color="white" v-if="logueado" @click="drawer = !drawer"/>
        <v-app-bar-title>
          S.I Flota Vehicular
        </v-app-bar-title>
        <v-spacer></v-spacer>

        <!--MENU DE OPCIONES PARA CERRAR SESION-->
        <v-menu v-if="logueado" class="menu_user" bottom left transition="scroll-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark class="mr-2" elevation="0" v-bind="attrs" offset-y v-on="on" content="Usuario" 
              v-tippy='{ placement : "bottom" }' >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-card class="rounded-lg" elevation="0" style="height: 180px; width: 200px;" >
            <v-card-text>
              <div class="mx-auto text-center">
                <v-avatar >
                  <v-img src="data:image/png;base64,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"></v-img>
                </v-avatar>
                <h3 class="mt-1">{{getUsuario}}</h3>
                <p class="text-caption mt-1">{{getRol}}</p>
              </div>
            </v-card-text>
            <v-divider class="mx-2"></v-divider>
            <v-card-actions class="pa-1 d-flex justify-center">
                <v-icon class="cursor-pointer" content="Cerrar sesión" v-tippy='{ placement : "bottom" }' @click="Salir()">
                  mdi-logout
                </v-icon>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-app-bar>

      <!--BARRA DE NAVEGACION-->
      <v-navigation-drawer v-model="drawer" app style="z-index: 100;" tile fixed class="white" v-if="logueado">
        <template #prepend>
          <v-container class="d-flex justify-center align-center my-0" 
            style="background-color: white;">
            <div class="pa-0">
              <!-- <img src="./assets/emprovisa/gorro.png" id="gorro" class="mt-0"/> -->
              <div class="d-flex flex-column">
                <img src="./assets/emprovisa/emprovisa.svg" alt="Emprovisa" style="width: 150px; height: 80px"
                  class="mt-0"/>
              </div>
            </div>
          </v-container>
        </template>

        <v-list dense nav>
          <!--HOME-->
          <v-list-item-subtitle class="py-2">
            Home
          </v-list-item-subtitle>
          <template v-if="esAdministrador || esGeneral ">
            <v-list-item :to="{ path: '/'}" dense dark active-class="indigo darken-4 white--text" style="color: black;"
              >
              <!--ICONO-->
              <v-list-item-icon>
                <v-icon>home</v-icon>
              </v-list-item-icon>

              <!--TEXTO-->
              <v-list-item-content>
                <v-list-item-title>
                  INICIO
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item-subtitle class="text-black py-2">
            Gestión Combustible
          </v-list-item-subtitle>

          <!--COMBUSTIBLE-->
          <template v-if="verMenuGeneral('COMBUSTIBLE')">
            <v-list-group prepend-icon="local_gas_station">
              <v-list-item slot="activator">
                <!--TEXTO-->
                <v-list-item-content>
                  <v-list-item-title class="color-blanco">
                  Combustible
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!--APARTADO COMBUSTIBLE.ORDENES-->
              <v-list-group v-if="verMenuGeneral('ORDEN')" no-action sub-group >
                <template v-slot:activator>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-content>
                        <v-layout :align-start="true">
                          <!--ICONO-->
                          <v-icon class="ml-0 mr-3">
                            format_list_numbered
                          </v-icon>

                          <!--TEXTO-->
                          <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco" style="height: 14px" >
                            órdenes
                          </v-list-item-title>

                        </v-layout>
                      </v-list-item-content>
                    </template>
                    <span>órdenes</span>
                  </v-tooltip>
                </template>

                <!--APARTADO COMBUSTIBLE.ORDENES.TIPO_ORDEN-->
                <v-tooltip v-if="verMenu('TIPO_ORDEN')" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item :to="{ name: 'tipo_orden'}" link class="ml-0 pl-16" >
                      <!--ICONO-->
                      <v-list-item-icon>
                        <v-icon>category</v-icon>
                      </v-list-item-icon>

                      <!--TITULO-->
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                        Tipo orden
                      </v-list-item-title>

                    </v-list-item>
                  </template>
                  <span>Tipos de ordenes</span>
                </v-tooltip>

                <!--APARTADO COMBUSTIBLE.ORDENES.TIPO_SERVICIO-->
                <v-tooltip v-if="verMenu('TIPO_SERVICIO')" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item :to="{ name: 'tipo_servicio'}" link class="ml-0 pl-16" >
                      <!--ICONO-->
                      <v-list-item-icon>
                        <v-icon>miscellaneous_services</v-icon>
                      </v-list-item-icon>

                      <!--TITULO-->
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                        Tipo Servicio
                      </v-list-item-title>

                    </v-list-item>
                  </template>
                  <span>Tipos de servicios</span>
                </v-tooltip>

                <!--APARTADO COMBUSTIBLE.ORDENES.ORDEN-->
                <v-tooltip v-if="verMenu('ORDEN')" right>
                  <template v-slot:activator="{ on, attrs }">

                    <v-list-item :to="{ name: 'ordenes'}" link class="ml-0 pl-16" >

                      <!--ICONO-->
                      <v-list-item-icon>
                        <v-icon>border_color</v-icon>
                      </v-list-item-icon>

                      <!--TITULO-->
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                        Orden
                      </v-list-item-title>

                    </v-list-item>
                  </template>
                  <span>Ordenes</span>
                </v-tooltip>
              </v-list-group>

              <v-list-group
                  v-if="verMenuGeneral('VEHICULO')"
                  no-action
                  sub-group
              >
                <template v-slot:activator>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">

                      <v-list-item-content>
                        <v-layout :align-start="true">
                          <v-icon class="ml-0 mr-3">garage</v-icon>
                          <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco" style="height: 14px">
                            Vehiculo
                          </v-list-item-title>
                        </v-layout>
                      </v-list-item-content>

                    </template>
                    <span>Vehiculos</span>
                  </v-tooltip>
                </template>

                <v-tooltip v-if="verMenu('TIPO_COMBUSTIBLE')" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item :to="{ name: 'tipo_combustible'}" link class="ml-0 pl-16">
                      <v-list-item-icon>
                        <v-icon>category</v-icon>
                      </v-list-item-icon>

                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                        Tipo Combustible
                      </v-list-item-title>


                    </v-list-item>
                  </template>
                  <span>Tipos de combustible</span>
                </v-tooltip>

                <v-tooltip v-if="verMenu('VEHICULO')" right>
                  <template v-slot:activator="{ on, attrs }">

                    <v-list-item :to="{ name: 'vehiculo'}" link class="ml-0 pl-16" >
                      <v-list-item-icon>
                        <v-icon>local_shipping</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                        Vehiculo
                      </v-list-item-title>


                    </v-list-item>

                  </template>
                  <span>Vehiculos</span>
                </v-tooltip>

              </v-list-group>

            </v-list-group>
          </template>

          <!--EMPLEADOS-->
          <template v-if="verMenuGeneral('EMPLEADO')">
            <v-list-group prepend-icon="badge" color="primary">
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title class="color-blanco">
                  Empleados
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!--APARTADO EMPLEADOS.CARGOS-->
              <v-tooltip v-if="verMenu('CARGO')" right >
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'cargo_empleado'}" class="ml-0 pl-8" >
                    <!--ICONO-->
                    <v-list-item-action class="mr-4">
                      <v-icon>work</v-icon>
                    </v-list-item-action>

                    <!--TEXTO-->
                    <v-list-item-content class="ml-0">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                      Cargos
                      </v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </template>
                <span>Cargos</span>
              </v-tooltip>

              <!--APARTADO EMPLEADOS.EMPLEADOS-->
              <v-tooltip v-if="verMenu('EMPLEADO')" right >
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'empleado'}" class="ml-0 pl-8" >
                    <!--ICONO-->
                    <v-list-item-action class="mr-4">
                      <v-icon>people</v-icon>
                    </v-list-item-action>

                    <!--TEXTO-->
                    <v-list-item-content class="ml-0">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                      Empleados
                      </v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </template>
                <span>Empleados</span>
              </v-tooltip>
            </v-list-group>
          </template>

          <!--REPORTES -->
          <template v-if="verMenuGeneral('REPORTE')">
            <v-list-group prepend-icon="summarize">
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title class="color-blanco">
                  Reportes
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!--APARTADO REPORTES.COMBUSTIBLE-->
              <v-tooltip v-if="verMenu('REPORTE_COMBUSTIBLE')" right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'reporte'}" class="ml-0 pl-8">
                    <!--ICONO-->
                    <v-list-item-action class="mr-0">
                      <v-icon>local_gas_station</v-icon>
                    </v-list-item-action>

                    <!--TITULO-->
                    <v-list-item-content class="ml-4">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                      Combustible
                      </v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </template>
                <span>Reporte de modulo combustible</span>
              </v-tooltip>
            </v-list-group>
          </template>

          <v-list-item-subtitle class="text-black py-2">
            Gestión Caja Chica
          </v-list-item-subtitle>
          <!--COMPROBANTES -->
          <template v-if="verMenuGeneral('COMPROBANTE')">
            <v-list-group prepend-icon="article" color="primary">
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title class="color-blanco">
                  Comprobantes
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!--APARTADO COMPROBANTES.COMPROBANTES-->
              <v-tooltip v-if="verMenu('COMPROBANTE')" right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'comprobantes'}" class="ml-0 pl-8">
                    <!--ICONO-->
                    <v-list-item-action class="mr-4">
                      <v-icon>mdi-file-document-plus</v-icon>
                    </v-list-item-action>

                    <!--TITULO-->
                    <v-list-item-content class="ml-0">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                      Comprobantes
                      </v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </template>
                <span>Comprobantes</span>
              </v-tooltip>

              <!--APARTADO REPORTES.COMPROBANTE-->
              <v-tooltip v-if="verMenu('REPORTE_COMPROBANTE')" right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'reporte_comprobante'}" class="ml-0 pl-8">
                    <!--ICONO-->
                    <v-list-item-action class="mr-0">
                      <v-icon>mdi-file-document-edit</v-icon>
                    </v-list-item-action>

                    <!--TITULO-->
                    <v-list-item-content class="ml-4">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                        Reportes
                      </v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </template>
                <span>Reporte de modulo Comprobantes</span>
              </v-tooltip>
            </v-list-group>
          </template>

          <v-list-item-subtitle class="text-black py-2">
            Gestión del Sistema
          </v-list-item-subtitle>
          <!--USUARIOS-->
          <template v-if="esAdministrador">
            <v-list-group prepend-icon="admin_panel_settings">
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title class="color-blanco">

                  Accesos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!--APARTADO USUARIOS.ROLES-->
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'roles'}" class="ml-0 pl-8">
                    <!--ICONO-->
                    <v-list-item-action class="mr-0">
                      <v-icon>supervised_user_circle</v-icon>
                    </v-list-item-action>

                    <!--TITULO-->
                    <v-list-item-content class="ml-4">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                      Roles
                      </v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </template>
                <span>Roles de usuario</span>
              </v-tooltip>

              <!--APARTADO USUARIOS.USUARIOS-->
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="{ name: 'usuarios'}" class="ml-0 pl-8">
                    <!--ICONO-->
                    <v-list-item-action class="mr-0">
                      <v-icon>account_circle</v-icon>
                    </v-list-item-action>

                    <!--TITULO-->
                    <v-list-item-content class="ml-4">
                      <v-list-item-title v-bind="attrs" v-on="on" class="color-blanco">
                      Usuarios
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Usuarios del sistema</span>
              </v-tooltip>
            </v-list-group>
          </template>

        </v-list>
      </v-navigation-drawer>

      <!--MAIN SEGUN ROUTER-->
      <v-main style="background-color: white;">
        <v-container fluid class="pa-0">
          <v-slide-y-transition mode="out-in">
              <keep-alive>
                <router-view v-if="$route.meta.keepAlive"/>
              </keep-alive>

          </v-slide-y-transition>
        </v-container>
      </v-main>

      <!-- FOOTER-->
      <v-footer padless style="background-color: white;">
        <v-col
            class="text-center"
            cols="12"
        >
          <strong>EMPROVISA - copyright @{{new Date().getFullYear()}} </strong>
        </v-col>
      </v-footer>

      <Sesion :activo="login_" @escucharResult="resultHijo()"></Sesion>
    </v-app>
  </v-responsive>
</template>

<script>
import router from './router';
import img from './assets/emprovisa/emprovisa.svg'
import gorro from './assets/emprovisa/gorro.png'
import hojas from './assets/emprovisa/adornos.png'
import Sesion from './components/Reutilizable/Secion_vencida'

  export default {
    data: () => ({

      //OCULTA O MUESTRA BARRA DE NAV.
      drawer: null,
      login_: false,

    }),

    components: {
      Sesion
    },

    computed: {

      //
      logueado(){
        if (this.$store.getters.getToken) {
          this.login_ = this.$store.getters.isExpired
          console.log(this.login_);
          
          return this.$store.getters.isExpired
            ? false
            : true
        }

        return false
      },

      esAdministrador(){
        return this.$store.getters.getRol && this.$store.getters.getRol === 'Administrador'
      },

      esGeneral(){
        return this.$store.getters.getUsuario
      },

      getUsuario() {
        if (this.logueado) {
          return this.$store.getters.getUsuario
        }
      },

      getRol() {
        if (this.logueado) {
          return this.$store.getters.getRol
        }
      },

      getPermisosEmp() {
        return this.$store.getters.getPermisos
      },

      getPermisosCmb() {
        return this.$store.getters.getPermisoCmb
      },

      getPermisosCmp() {
        return this.$store.getters.getPermisoCmp
      },

      getPermisosRp() {
        return this.$store.getters.getPermisoRp
      },

    },

    created () {
      const requestRoute = window.location.href
      const [route, path ] = requestRoute.split('#')
      this.$store.dispatch("autoLogin", path);  
    },

    methods:{
      resultHijo() {
        this.login_ = false;
      },

      //salir del login
      Salir(){
        this.$store.dispatch("salir");
      },
      //RETORNA BOOL, QUE INDICA SI TIENE PERMISOS SOBRE UN SUB_MENU
      verMenu(tipo){
        var result = false;

        switch(tipo){
          case 'CARGO':
            if(this.contador(
              this.getPermisosEmp,
              this.$permiso_cargo)>0){
              result = true;
            }
          break;
          case 'EMPLEADO':
            if(this.contador(
              this.getPermisosEmp,
              this.$permiso_empleado)>0){
              result = true;
            }
          break;
          case 'TIPO_ORDEN':
            if(this.contador(
              this.getPermisosCmb,this.$permiso_tipo_orden)>0){
              result = true;
            }
          break;
          case 'TIPO_SERVICIO':
            if(this.contador(
              this.getPermisosCmb,this.$permiso_tipo_servicio)>0){
              result = true;
            }
          break;
          case 'ORDEN':
            if(this.contador(
              this.getPermisosCmb,this.$permiso_orden)>0){
              result = true;
            }
          break;
          case 'TIPO_COMBUSTIBLE':
            if(this.contador(
              this.getPermisosCmb,this.$permiso_tipo_combustible)>0){
              result = true;
            }
          break;
          case 'VEHICULO':
            if(this.contador(
              this.getPermisosCmb,this.$permiso_vehiculo)>0){
              result = true;
            }
          break;
          case 'COMPROBANTE':
            if(this.contador(
              this.getPermisosCmp,this.$permiso_comprobante)>0){
              result = true;
            }
          break;
          case 'REPORTE_COMBUSTIBLE':
            if(this.contador(
              this.getPermisosRp,this.$permiso_reporte_combustible)>0){
              result = true;
            }
          break;
          case 'REPORTE_COMPROBANTE':
            if(this.contador(this.getPermisosRp,this.$permiso_reporte_comprobante)>0){
              result = true;
            }
          break;
        }

        return result;
      },
      //RETORNA BOOL, QUE INDICA SI TIENE PERMISOS SOBRE UN MENU PRINCIAPAL
      verMenuGeneral(tipo){
        var result = false;

        switch(tipo){
          case 'EMPLEADO':
              result =
                !(this.contador(
                  this.getPermisosEmp,
                    this.$permiso_cargo) <= 0 &&
                    this.contador(
                      this.getPermisosEmp,
                        this.$permiso_empleado) <= 0)
            break;
          case 'ORDEN':
            result =
                !(this.contador(
                  this.getPermisosCmb, this.$permiso_tipo_orden) <= 0 &&
                    this.contador(
                      this.getPermisosCmb, this.$permiso_tipo_servicio) <= 0 &&
                    this.contador(
                      this.getPermisosCmb, this.$permiso_orden) <= 0)
            break;
          case 'VEHICULO':
            result =
                  !(this.contador(
                    this.getPermisosCmb, this.$permiso_tipo_combustible) <= 0 &&
                      this.contador(
                        this.getPermisosCmb, this.$permiso_vehiculo) <= 0)
            break;
          case 'COMBUSTIBLE':
            result =
                !(this.contador(
                  this.getPermisosCmb, this.$permiso_tipo_orden) <= 0 &&
                    this.contador(
                      this.getPermisosCmb, this.$permiso_tipo_servicio) <= 0 &&
                    this.contador(
                      this.getPermisosCmb, this.$permiso_orden) <= 0 &&
                    this.contador(
                      this.getPermisosCmb, this.$permiso_tipo_combustible) <= 0 &&
                    this.contador(
                      this.getPermisosCmb, this.$permiso_vehiculo) <= 0)
            break;
          case 'COMPROBANTE':
            result =
                this.contador(
                  this.getPermisosCmp, this.$permiso_comprobante) > 0
            break;
          case 'REPORTE':
            result =
                !(this.contador(this.getPermisosRp, this.$permiso_reporte_combustible) <= 0
                    && this.contador(this.getPermisosRp, this.$permiso_reporte_comprobante)
                    <= 0)
            break;
        }

        return result;
      },
      contador(data,permiso){
        var result = 0;
        var aux = data !=null? data.split(','):this.salir_cambio_token();

        for(var i=0;i<permiso.length;i++)
        {
          for(var j=0;j<aux.length;j++)
          {
            if(permiso[i]===aux[j]){
              result ++;
              break;
            }
          }
        }
        return result;
      },
      //funcion funcionara si se realiza un cambio en los claims del token
      salir_cambio_token(){
        alert('Error al cargar los componentes ,'+
        'por los permisos de usuarios (Comunicate con el administrador del sitio y valide el token.)');
          //elimina un token ya preregistrado
        this.$store.dispatch("salir");
      }
    }
  }
</script>

<style scoped>
#gorro{
  position: absolute;
  /* width: 30% !important;
  height: 50% !important; */
  width: 20%;
  top: 15px;
  right: 15px;
  background: transparent;
  padding: 0 !important;
  rotate: 45deg;
}

.hojas {
  position: absolute !important;
  top: 1%;
  left: 10%;
  width: 20%;
}

#text-logo, #text-logo small{
  font-size: 10px;
}

.border {
  border: .5px solid lightgrey !important;
}

.color >  .v-list-group, .v-list-item .v-icon {
  color: #000000 !important;
}
.color-blanco{
  color: #000000 !important;
}
.v-navigation-drawer > .v-list-group, .v-list-item__title {
  font-size: 12px !important;
  font-weight: bold;
}
.v-list-item__title{
  text-transform: uppercase !important;
}
.v-list-group__header__prepend-icon{
  margin-right: 15px !important;
}
/* .color{
  background: #212120 !important;
} */
.v-divider{
  background: #f2f2f2;
  margin-left: 10%;
}
.container{
  background: #f2f2f2;
}

.text-color{
  color: black !important;
}

.img{
  margin-top: 0 !important;
  /* width: 80px !important; */
  height: 70px !important;
}

.menu_user{
  top: 55px !important;
  height: 180px !important;
}

@media (max-width: 600px) {
    td{
    width:100% !important;
  }
}
.tippy-tooltip {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}

.v-list-item--dense, .v-list--dense .v-list-item {
  height: 20px !important;
}

</style>